export default __webpack_public_path__ + "static/barcelona_code_school_campus_-2-57cec8b8722bdc041ed91245d0296427.jpg";